var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAwesomeClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.88,
    height: 18.88,
    viewBox: "0 0 18.88 18.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M10,.563A9.44,9.44,0,1,0,19.443,10,9.438,9.438,0,0,0,10,.563Zm2.173,13.326-3.357-2.44a.46.46,0,0,1-.187-.369V4.673a.458.458,0,0,1,.457-.457h1.827a.458.458,0,0,1,.457.457V9.915l2.417,1.759a.456.456,0,0,1,.1.639L12.815,13.79A.46.46,0,0,1,12.176,13.889Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#446fa2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeClock);
export default __webpack_public_path__ + "static/media/icon-awesome-clock.2383f261e3c05f28e9cefbaaa26a358d.svg";
export { ForwardRef as ReactComponent };